<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button icon="el-icon-plus" type="primary" @click="handleAdd">
          新增房型
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item style="margin-right: 10px !important">
            <el-select
              v-model="queryForm.apartmentId"
              clearable
              filterable
              remote
              :remote-method="getApartments"
              placeholder="所属公寓"
            >
              <el-option
                v-for="item in apartments"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right: 10px !important">
            <el-input v-model.trim="queryForm.keyword" placeholder="房型名称" />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table v-loading="listLoading" border :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="所属公寓"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ row.apartment && row.apartment.title }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="房型名称"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="合租模式" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag v-if="row.basic.mode == 1">整租</el-tag>
          <el-tag v-if="row.basic.mode == 2">合租</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="left" label="面积" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag>{{ row.basic && row.basic.area }}㎡</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="left" label="价格" show-overflow-tooltip width="260">
        <template #default="{ row }">
          <el-tag v-for="(item, index) in row.basic && row.basic.priceList" :key="index">
            {{ item.price }}每{{row.basic.period==1?'周':'月'}}/{{ item.lease }}{{row.basic.period==1?'周':'个月'}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="left" label="入住时间" show-overflow-tooltip>
        <template #default="{ row }">
          {{ moment(Number(row.basic && row.basic.enterTimeList&& row.basic.enterTimeList[0])).format('YYYY-MM-DD HH:mm:ss')||moment(row.basic && row.basic.enterTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="标签"
        prop="basic.tag"
        show-overflow-tooltip
      />
      <!-- <el-table-column align="left" label="房型图片" show-overflow-tooltip>
        <template #default="{ row }">
          <el-avatar
            shape="square"
            :size="50"
            :src="row.image && row.image[0] && row.image[0].url"
            fit="contain"
          ></el-avatar>
        </template>
      </el-table-column> -->
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="180px"
      >
        <template #default="{ row }">
          <!-- <el-button type="text" @click="handleShow(row)">详情</el-button> -->
          <el-button type="text" @click="handleEdit(row)">修改</el-button>
          <el-button type="text" @click="handleUpdate(row)">{{ row.step === 1 ? '上架' : '下架' }}</el-button>
          <el-button
                      size="small"
                      type="text"
                      @click="handleCopy(row)"
                      >复制</el-button
                    >
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { findRoomList, removeRoom, updateRoom, findBuildingList } from '@/api/apartment'
import Edit from './edit'
import store from 'store'
// import Show from './show'
export default {
  name: 'Room',
  components: {Edit },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
        apartmentId: '',
      },
      apartments: [],
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/apartment/room') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
    this.getApartments()
  },
  methods: {
    async getApartments(queryString) {
      try {
        const keyword = typeof queryString == 'object' ? '' : queryString
        const res = await findBuildingList({
          page: 1,
          size: 20,
          keyword
        })
        this.apartments = res && res.list.map(i => ({
          label: i.title,
          value: i.apartmentId
        }))
      } catch (error) {
        this.apartments = []
      }
    },
    handleShow(row) {
      this.$refs['show'].show(row)
    },
    async handleUpdate(row) {
      const result = await updateRoom({
        roomId: row.roomId,
        step: row.step === 1 ? 2 : 1
      })
      if (result) {
        this.$message.success(`${row.step === 1 ? '上架' : '下架'}成功`)
        this.fetchData()
      }
    },
    handleAdd() {
      const row = store.get("roomData");
      if(row){
        this.$refs['edit'].showEdit(row,'add')
      }else{
        this.$refs['edit'].showEdit(row)
      }
    },
    handleEdit(row) {
      this.$refs['edit'].showEdit(row,'edit')
    },
    handleDelete(row) {
      if (row.roomId) {
        this.$baseConfirm(`你确定要删除该房型吗`, null, async () => {
          await removeRoom({ roomId: row.roomId })
          this.$baseMessage(
            '删除房型成功',
            'success',
            false,
            'vab-hey-message-success'
          )
          await this.fetchData()
        })
      }
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    handleCopy(row) {
      row.apartmentId = ''; // 清除适用范围
      row.roomId = ''; // 清除适用范围
      store.set("roomData", row);
      this.$message.success(`已将当前房型信息复制到粘贴板！`);
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findRoomList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar {
  width: 40px;
  height: 40px;
}
</style>
